import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bullet-menu',
  templateUrl: './bullet-menu.component.html',
  styleUrls: ['./bullet-menu.component.scss']
})
export class BulletMenuComponent implements OnInit {
  @Input() choices: string[] = [];
  @Input() selected = -1;
  @Output() select: EventEmitter<number> = new EventEmitter<number>();
  public visibleChoice = -1;
  constructor() { }

  ngOnInit() {
  }
  doSelect(index: number) {
    this.visibleChoice = -1;
    this.select.emit(index);
  }
}
